import React  from 'react';

const SZMinilottoTicket = ({ children }) => {
  return (
    <div className="szMinilottoTicket flexCentered">
      <div className="childrenContainer flexCentered">
        { children }
      </div>

      <style jsx>
        {`
          .szMinilottoTicket {
            font-family: 'Press Start 2P', 'Montserrat', sans-serif;
            position: relative;
            width: 100%;
            padding-top: 100%;
            border: 3px solid #50E3C2;
            border-radius: 2px;
            text-align: center;
            font-size: 1.5em;
            font-weight: 600;
            line-height: 0;
          }
          
          .childrenContainer {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
          }
          
        `}
      </style>
    </div>
  );
};

export default SZMinilottoTicket;
